var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineSearchUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_x2F_outline_x2F_search-user_00000116201166237929146580000001956478070282013874_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24,0L24,0v24H0V0H24z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_x2F_outline_x2F_search-user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "{props.color}",
    d: "M1.2,11c0-5.4,4.4-9.8,9.8-9.8s9.8,4.4,9.8,9.8s-4.4,9.8-9.8,9.8S1.2,16.4,1.2,11z M2.8,11 c0,4.6,3.7,8.2,8.2,8.2s8.2-3.7,8.2-8.2S15.6,2.8,11,2.8S2.8,6.4,2.8,11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000067941973318153201820000017315305380309068675_",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "{props.color}",
    d: "M10.9,10.7c-1.4,0-2.5-1.1-2.5-2.5 c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5C13.4,9.5,12.4,10.6,10.9,10.7C11,10.7,11,10.7,10.9,10.7C11,10.7,11,10.7,10.9,10.7z  M9.9,8.2c0,0.6,0.4,1,1,1c0,0,0,0,0.1,0c0.5,0,0.9-0.5,0.9-1c0-0.6-0.5-1-1-1S9.9,7.6,9.9,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000093868914819416073660000014372685102158266799_",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "{props.color}",
    d: "M8.6,15.7c-0.7-0.4-1.1-1.1-1.1-1.8 c0-0.7,0.4-1.3,1.1-1.8c1.4-0.9,3.5-0.9,4.8,0c0.7,0.4,1.1,1.1,1.1,1.8c0,0.7-0.4,1.3-1.1,1.8c-0.7,0.4-1.5,0.7-2.4,0.7 C10.1,16.3,9.3,16.1,8.6,15.7z M9,13.9c0,0.2,0.1,0.4,0.4,0.5c0.8,0.6,2.3,0.6,3.1,0c0.2-0.2,0.4-0.4,0.4-0.5s-0.1-0.4-0.4-0.5 c-0.8-0.6-2.3-0.6-3.2,0C9.2,13.5,9,13.7,9,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000047746406330182925310000009637847998735613106_",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "{props.color}",
    d: "M19.9,22.8c-0.5-0.1-1.3-0.4-1.8-1.8 c-0.2-0.8-0.2-1.5,0.2-2.1s1.1-0.9,1.9-0.9c1,0,1.8,0.4,2.2,1.1s0.3,1.6-0.3,2.4c-0.7,1.1-1.5,1.3-2,1.3 C20.1,22.8,20,22.8,19.9,22.8z M20.1,21.3c0.2,0,0.5-0.2,0.8-0.6c0.3-0.4,0.3-0.7,0.2-0.9c-0.1-0.1-0.4-0.3-0.9-0.3 c-0.3,0-0.5,0.1-0.7,0.3c-0.1,0.2-0.1,0.4,0,0.7C19.7,21,20,21.3,20.1,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000093867584089299817610000011145222042430566074_",
    fill: "none",
    d: "M24,0v24H0V0H24z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineSearchUser);
export default __webpack_public_path__ + "static/media/vuesax-outline-search-user.eee07ddbd8d8b2ad2c90ff9aeb19ed1f.svg";
export { ForwardRef as ReactComponent };